document.addEventListener('DOMContentLoaded', function() {
    const filterButtons = document.querySelectorAll('.articles-tag-filter__button');
    const articleItems = document.querySelectorAll('.articles-grid__item');
    
    filterButtons.forEach(button => {
      button.addEventListener('click', function() {
        const selectedTag = this.getAttribute('data-articles-tag');
        
        // Update active button state
        filterButtons.forEach(btn => btn.classList.remove('articles-tag-filter__button--active'));
        this.classList.add('articles-tag-filter__button--active');
        
        // Filter articles
        articleItems.forEach((item, index) => {
          const itemTags = item.getAttribute('data-tags');
          
          if (!selectedTag) {
            // Show all articles (first button)
            item.style.display = 'flex';
            item.style.opacity = '1';
          } else {
            // Filter by specific tag (case-insensitive)
            if (itemTags) {
              const itemTagsArray = itemTags.toLowerCase().split(' ');
              const tagExists = itemTagsArray.some(tag => tag === selectedTag.toLowerCase());
              
              if (tagExists) {
                item.style.display = 'flex';
                item.style.opacity = '1';
              } else {
                item.style.display = 'none';
                item.style.opacity = '0';
              }
            } else {
              // If no data-tags attribute, hide the item
              item.style.display = 'none';
              item.style.opacity = '0';
            }
          }
        });
      });
    });
  }); 